import usePostData from '../../../../../hooks/postHook';

export const useAddInvoice = ({ isEditing }) => {
  const [{ data, body, isLoading, isError, error }, doAddInvoice] = usePostData(
    ``,
    {
      type: isEditing ? 'put' : 'post',
    }
  );

  return { data, body, isLoading, isError, error, doAddInvoice };
};
